import BaseClass from "../BaseClass";

export default class Address extends BaseClass {
    constructor(element) {
        super(element);

        this.jqxhr = null;

        this.initElements();
        this.initListeners();

        this.showStartupErrors();
    }

    initElements() {
        this.$csrfMeta = $(document).find('meta[name="csrf-token"]');
        this.$selectedAddress = this.$element.find('[name="address[id]"]');
        this.$fieldset = this.$element.find('fieldset.address-inputs');
        this.$form = this.$element.parents('form');
        this.$country = this.$form.find('[name="address[country]"]');
        this.$csrfToken = this.$form.find('[name="_token"]');
    }

    initListeners() {
        this.$element.on('address:fail', $.proxy(this.onFail, this));
        this.$element.on('address:submit', $.proxy(this.onSubmit, this));
        this.$country.on('change', $.proxy(this.onCountryChange, this));
    }

    onFail(event, data) {
        if (this.jqxhr != null) {
            this.jqxhr.abort();
            this.jqxhr = null;
        }

        this.$fieldset.prop('disabled', false);
        this.$fieldset.filter('.hidden').removeClass('hidden');

        this.$selectedAddress.val('');

        this.$element.trigger('address:failed');
    }

    onSubmit(event) {
        const self = this;

        const selectedAddress = this.$selectedAddress.val();
        if (selectedAddress != undefined && String(selectedAddress).trim() != '') {
            return;
        }

        if (this.jqxhr != null) {
            return;
        }

        const url = this.$element.data('url');

        if (typeof url == 'undefined') {
            return;
        }

        const data = this.$fieldset.serialize();

        this.$fieldset.prop('disabled', true);
        this.jqxhr = $.post(url, data, null, 'json')
            .done($.proxy(this.onSubmitSuccess, this))
            .fail($.proxy(this.onSubmitFail, this))
            .always(function () {
                self.$fieldset.prop('disabled', false);

                self.jqxhr = null;
            });

        event.stopPropagation();
        event.preventDefault();
    }

    onSubmitSuccess(data, textStatus, jqXHR) {
        const csrfToken = jqXHR.getResponseHeader('X-CSRF-TOKEN');
        if (csrfToken != undefined) {
            $.ajaxSetup({
                headers: {
                    'X-CSRF-TOKEN': csrfToken
                }
            });
            this.$csrfMeta.prop('content', csrfToken);
            this.$csrfToken.val(csrfToken);
        }

        if (data?.success && data?.data?.id != undefined) {
            this.$element.data('address', data.data);
            this.$selectedAddress.val(data.data.id);
            this.$fieldset.prop('disabled', true);

            this.$fieldset.not('.hidden').addClass('hidden');

            this.$element.trigger('address:ready', {address: data.data});

            return;
        }

        this.$element.trigger('address:failed');
    }

    onSubmitFail(jqXHR, textStatus, errorThrown) {
        if (jqXHR?.responseJSON?.errors != undefined) {
            this.displayValidationErrors(jqXHR.responseJSON.errors);
        }

        this.$element.trigger('address:failed');
    }

    displayValidationErrors(errors) {
        // const $tmpl1 = $('#form_validation_error_tpl').contents();
        const $tmpl = $('<div class="validation validation--error"><span class="validation-message"></span><i class="fa-solid fa-circle-exclamation"></i></div>');

        const self = this;

        for (const field in errors) {
            const message = errors[field];

            const fieldParts = field.split('.');

            let fieldName = fieldParts.shift();

            for (const fieldPart of fieldParts) {
                fieldName += '[' + fieldPart + ']';
            }

            const $inputElement = self.$fieldset.find('label[for="' + fieldName + '"], :input[name="' + fieldName + '"], fieldset[name="' + fieldName + '"]').first();
            if ($inputElement.length == 1) {
                const $errorContainer = $tmpl.clone();
                const $message = $errorContainer.find('.validation-message');

                $errorContainer.prop('for', fieldName);
                $message.html(message);

                $inputElement.after($errorContainer);

                const removeErrorContainerCb = function () {
                    $inputElement.off('click', removeErrorContainerCb);
                    $errorContainer.off('click', removeErrorContainerCb);
                    $inputElement.off('focus', removeErrorContainerCb);

                    $errorContainer.remove();
                }

                $inputElement.on('click', removeErrorContainerCb);
                $errorContainer.on('click', removeErrorContainerCb);
                $inputElement.on('focus', removeErrorContainerCb);
            }
        }
    }

    onCountryChange() {
        this.$element.trigger(
            'address:country:changed',
            {
                country: this.$country.val(),
            }
        );
    }

    showStartupErrors() {
        const startupErrors = this.$element.data('startup-errors');

        if (startupErrors != undefined) {
            this.displayValidationErrors(startupErrors);
        }
    }

    destroyListener() {
        if (this.jqxhr != null) {
            this.jqxhr.abort();
            delete this.jqxhr;
        }

        this.teardownListeners();
        this.teardownElements();
    }

    teardownElements() {
        delete this.$csrfMeta;
        delete this.$selectedAddress;
        delete this.$fieldset;
        delete this.$form;
        delete this.$country;
        delete this.$csrfToken;
    }

    teardownListeners() {
        this.$element.off('address:fail', $.proxy(this.onFail, this));
        this.$form.off('address:submit', $.proxy(this.onSubmit, this));
        this.$country.off('change', $.proxy(this.onCountryChange, this));
    }
}